module.exports = __webpack_public_path__ + "assets/images/home/background-mobile.0ce3638c244b684e9f1ea5d40c696b5e.webp";